import { theme } from '@/client/components'
import styled from 'styled-components'
const { space, breakpoint } = theme

export const WrapCalculator = styled.div`
  top: -${space.lg};
  position: relative;
`
export const WrapHeroCalculator = styled.div`
  background: radial-gradient(ellipse at center top, rgba(24, 68, 84, 0.5) 10%, rgba(255, 255, 255, 0) 60%),
    radial-gradient(ellipse at top, rgba(0, 40, 70, 0.6) 0%, rgba(0, 40, 70, 0.2) 20%, transparent 100%),
    linear-gradient(
      to bottom,
      #000818 0%,
      #002b45 20%,
      #00aee9 50%,
      rgba(255, 255, 255, 0.05) 65%,
      rgba(255, 255, 255, 0.25) 75%,
      rgba(255, 255, 255, 0.6) 85%,
      rgba(255, 255, 255, 0.9) 95%,
      #ffffff 100%
    );
  background-blend-mode: screen, overlay, normal;
  background-size: cover, no-repeat;
  background-repeat: no-repeat;
  background-position: top center;
`
